import React, { useEffect, useState, useRef } from "react";
import {
  defineBlock,
  smartProps,
  useSmartProp,
  useInspectorControl,
  useEditor,
} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, TextControl, Panel } from "@wordpress/components";
import apiFetch from "@wordpress/api-fetch";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import style from "./block.module.scss";
import { ReactComponent as ArrowSVG } from "./fleche.svg";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import BackgroundGrid from "../shared/BackgroundGrid.js";

function Inspector() {
  const [ancreId, setAncreId] = useSmartProp("ancreId");
  return (
    <PanelBody title="Ancre" initialOpen={true}>
      <PanelRow>
        <TextControl
          label="Ancre (id)"
          value={ancreId}
          onChange={(value) => setAncreId(value)}
        />
      </PanelRow>
    </PanelBody>
  );
}

function Block({ ancreId }) {
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();
  const sliderRef = useRef();
  const [postsList, setPostsList] = useState([]);
  const [category, setCategory] = useSmartProp("category");
  const [categories, setCategories] = useState(false);
  const [filter, setFilter] = useState();

  useEffect(() => {
    apiFetch({
      path: `/wp/v2/posts?per_page=3&product-category=${category}`,
    }).then((data) => {
      setPostsList(data);
    });
    apiFetch({ path: "/wp/v2/all-terms?term=product-category" }).then(
      (terms) => {
        setCategories(terms);
      }
    );
  }, [setPostsList, setCategories, category]);

  useEffect(() => {
    const categorySlugs = {
      evenements: "event",
      "construction-modulaire": "construction",
      industrie: "industrie",
      "nos-solutions-frigorifiques": "frigorifique",
    };
    const arrayPathname = window.location.pathname.split("/");
    if (arrayPathname) {
      Object.keys(categorySlugs).forEach((index) => {
        if (arrayPathname[1] === index) setFilter(categorySlugs[index]);
      });
    }
  }, []);

  const settingsSlider = {
    dots: false,
    arrows: false,
    speed: 300,
    infinite: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
  };

  const renderEdit = () => {
    return (
      <Panel>
        <PanelBody>
          <Typography variant="subtitle1">Réalisations concernées</Typography>
          <FormControl style={{ width: "100%", minHeight: "1.75em" }}>
            <InputLabel htmlFor="select-chip">
              Catégorie de réalisations à afficher
            </InputLabel>
            <Select
              value={category || ""}
              onChange={(cat) => setCategory(cat.target.value + "")}
              input={<Input id="select-chip" />}
              renderValue={(selected) => (
                <div>
                  {!selected ? (
                    <div>
                      <Chip label={"Aucun produit selectionné"} />
                    </div>
                  ) : (
                    <>
                      <Chip
                        label={
                          categories &&
                          categories.map(
                            (cat) =>
                              cat.term_id === parseInt(category, 10) && cat.name
                          )
                        }
                      />
                    </>
                  )}
                </div>
              )}
            >
              {categories &&
                categories.map((c) => (
                  <MenuItem key={c.term_id} value={c.term_id}>
                    {c.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </PanelBody>
      </Panel>
    );
  };

  return (
    <div className={style.block}>
      {isEditing ? (
        renderEdit()
      ) : (
        <div className="content-container">
          <div className={style.contentWidth}>
            <Slider ref={sliderRef} {...settingsSlider}>
              {postsList &&
                postsList.map((post, indexSlide) => (
                  <div className={style.contentSlide} key={indexSlide}>
                    <div className={style.content}>
                      <div className={style.content_descr}>
                        <div
                          className={style.title}
                          dangerouslySetInnerHTML={{
                            __html: post.title.rendered,
                          }}
                        />
                        <div
                          className={style.descr}
                          dangerouslySetInnerHTML={{ __html: post.short_descr }}
                        />
                        <div className={style.btn}>
                          <a href={post.link}>Découvrir ce cas client</a>
                        </div>
                      </div>
                      <BackgroundGrid color="blue" />
                    </div>
                    <div className={style.media}>
                      <img src={post.featured_image_src} alt="real" />
                    </div>
                  </div>
                ))}
            </Slider>
            <div className={style.arrows}>
              <div onClick={() => sliderRef.current.slickPrev()}></div>
              <div onClick={() => sliderRef.current.slickNext()}></div>
            </div>
            <div className={style.seeAll}>
              <a href={"/nos-realisations/?filter=" + filter}>
                <ArrowSVG />
                Voir nos réalisations
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    category: smartProps.string.withDefault(),
  },
  setup: {
    title: "Realisations",
  },
});
